const s = {
  name: "Receipt",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,7h9V5h-9V7z"/>
		<path class="st0" d="M22,12h-9v-2h9V12z"/>
		<path class="st0" d="M13,17h9v-2h-9V17z"/>
		<path class="st0" d="M22,22h-9v-2h9V22z"/>
		<path class="st0" d="M13,27h9v-2h-9V27z"/>
		<path class="st0" d="M27,7h-2V5h2V7z"/>
		<path class="st0" d="M25,12h2v-2h-2V12z"/>
		<path class="st0" d="M27,17h-2v-2h2V17z"/>
		<path class="st0" d="M25,22h2v-2h-2V22z"/>
		<path class="st0" d="M7.6,15H8v25h2.4l2.6-2.6l2.6,2.6h1.8l2.6-2.6l2.6,2.6h1.8l2.6-2.6l2.6,2.6H32V5c0-2.8-2.2-5-5-5H5
			C2.2,0,0,2.2,0,5v10h2.4L5,12.4L7.6,15z M5,2c1.7,0,3,1.3,3,3v7.6l-3-3l-3,3V5C2,3.3,3.3,2,5,2z M10,5c0-1.1-0.4-2.2-1-3h18
			c1.7,0,3,1.3,3,3v32.6l-3-3L23.6,38h-0.2L20,34.6L16.6,38h-0.2L13,34.6l-3,3V5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Receipt
};
